/**
 * 大搜消息逻辑组件
 * 核心功能：初始化数据(init) 数据获取(getmessageList) 分页加载数据(loadmoreFn) 缓存数据(tmpmessageList)用于点击返回按钮是展示，不用再次请求数据。
 * 控制加载动画(loading) 是否显示加载更多数据(loadMore) 控制是否有返回按钮(isShowBackBtn)
 */
import React, { useEffect, useState, useMemo, useRef } from "react";
import { SearchType } from "@/services/SearchService";
import { SearchMessageHistoryListUI } from "./SearchMessageHistoryUI";
import { ChatMessage, ChatMessageType } from "@/types/chat";
import ImService from "@/server/ImService";
import { useHistory } from "react-router-dom";
import bus from "@/utils/bus";
import { connect } from "dva";
import { getChatLocationPath } from "@/utils/chat";
import { getGroupInfo } from "@/api/egroup";
import { message } from "antd";
import { analysisLog } from "@/utils/logAnalytics";
import { getMsgContent, removeFirstOccurrence } from "@/utils/chat/message";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { SearchGlobalContext } from "./utils";
import dayjs from "dayjs";

interface Item {
  avatar: string;
  name: string;
  mid: number;
  sessionId: string;
  url: string;
  isGroup: boolean;
  children?: Item[];
  isSingle?: boolean;
  info: any;
}
interface IProps {
  keyWord: string;
  activeKey: string;
  limit?: number;
  t: any;
  clearSessionMessage?: Function;
  setHistoryMessage?: Function;
  updateMessages?: Function;
  setSelectorSwitch?: Function;
}

let currentMid = "";
let laetId: any = 0;
const SeacrchMassageHistoryList = (props: IProps) => {
  const {
    keyWord = "",
    activeKey = SearchType.MessageHistory,
    limit = 1000,
    t,
    clearSessionMessage,
    setHistoryMessage,
    updateMessages,
    setSelectorSwitch = ""
  } = props;
  // keyVal = keyWord;
  const [tmpmessageList, setTmpMessageList] = useState<any[]>([]); // 临时存储数据
  const [messageList, setMessageList] = useState<any[]>([]);
  const [loading, setLoaing] = useState(true);
  const [loadMore, setLoadMore] = useState(false);
  const [isShowBackBtn, setShowBackBtn] = useState(false);
  const imService = ImService.getInstance();
  const currPage = useRef(0);
  const history = useHistory();
  const [filterList, setFilterList] = useState<any[]>([]);
  const { sessionType, msgType, senderList, msgTime } = React.useContext(
    SearchGlobalContext
  );
  // 处理数据
  const handleData = (item: any) => {
    const isSingle =
      item.sessionId.indexOf(`:${(window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID}:`) !== -1 ? true : false;
    let url = "";
    if (isSingle) {
      const { app, teamId, userId, sessionId } = item.requestData;
      url = `/messages/s/${userId}?app=${app}&tid=${teamId}&top=${true}&sMid=${
        item.mid
      }&sText=${keyWord}&sTimestamp=${item.timestamp}`;
      if (sessionId.endsWith("secret")) {
        url = `/messages/s/${userId}:secret?app=${app}&tid=${teamId}&top=${true}&sMid=${
          item.mid
        }&sText=${keyWord}&sTimestamp=${item.timestamp}&secret=true`;
      }
    } else {
      url = `/messages/g/${item.sessionId}?sMid=${item.mid
        }&top=${true}&sText=${keyWord}&sTimestamp=${item.timestamp}`;
    }
    let content = item.content;
    if (item.type !== ChatMessageType.TEXT) {
      content = getMsgContent(item, keyWord);
    } 
    if (item.type === ChatMessageType.TEXT && item?.quillImage?.length) {
      content = removeFirstOccurrence(content, i18n.t("chat:quill-old-version-tip"));
    }
    return {
      avatar: (item.requestData && item.requestData.avatar) || "",
      name: (item.requestData && item.requestData.name) || "",
      kind: (item.requestData && item.requestData.kind) || "",
      subKind: (item.requestData && item.requestData.subKind) || "",
      labelInfoList: (item.requestData && item.requestData.labelInfoList) || "",
      nickName: item.nickName,
      desc: content,
      isGroup: false,
      mid: item.mid,
      sessionId: item.sessionId,
      url,
      isSingle,
      info: item.requestData,
      timestamp: item.timestamp,
      type: item.type,
      sender: {
        app: item.sender.app,
        teamId: item.sender.teamId,
        pin: item.sender.userId
      }
    };
  };
  // 加载数据
  async function loadSingeExportMessages(searchKey = "", offset = 0) {
    const msgs = await imService.search(
      {
        sessionId: "",
        searchKey,
        searchTypes: [
          ChatMessageType.TEXT,
          ChatMessageType.TEMPLATE2,
          ChatMessageType.JOYSPACEFILE,
          ChatMessageType.FILE,
          ChatMessageType.EGOV_FILE,
          ChatMessageType.LOCATION_JD,
          ChatMessageType.LOCATION,
          ChatMessageType.GROUPNOTICE,
          ChatMessageType.SOLITAIRE
        ],
        limit,
        queryType: 2,
        offset,
        incluedUser: false,
        incluedCard: true
      },
      true
    );
    msgs.sort((a: any, b: any) => b.timestamp - a.timestamp);
    console.log("消息记录处理前的数据列表", msgs);
    // const filtermsgs = msgs.filter((item: any) => {
    //   if (item.type === ChatMessageType.TEXT && item?.quillImage?.length) {
    //     if (item.content.includes(i18n.t("chat:quill-old-version-tip"))) {
    //       let removeTag = removeFirstOccurrence(item.content, i18n.t("chat:quill-old-version-tip"));
    //       if (!removeTag.includes(searchKey)) {
    //         return false;
    //       }
    //     }
    //   }
    //   return true;
    // })
    // 消息聚合
    const list: Item[] = [];
    for (let item of msgs) {
      // const mid = (item as any).mid || -1;
      if (
        !(item as any).requestData ||
        ((item as any).requestData && !(item as any).requestData.name)
      ) {
        continue;
      }
      const _item = list.find((_item: Item) => _item.sessionId === (item as any).sessionId) || null;
      if (!_item) {
        const result: Item = handleData(item);
        result.children = [];
        list.push(result);
        continue;
      }
      _item.isGroup = true;
      if (!_item.children?.length) {
        const res = { ..._item };
        res.isGroup = false;
        delete res.children;
        _item.children = [res];
      }
      _item.children?.push(handleData(item));
    }
    console.log("消息记录处理后的数据列表", list);
    return list;
  }
  const init = () => {
    currPage.current = 0;
    setLoadMore(false);
    setLoaing(true);
    setShowBackBtn(false);
    setMessageList([]);
    setTmpMessageList([]);
    setFilterList([]);
    setSelectorSwitch && setSelectorSwitch(true);
  };
  const getmessageList = (searchKey = "", offset = 0) => {
    laetId++;
    return async (theLastId: any) => {
      if (!searchKey) {
        setMessageList([]);
        setTmpMessageList([]);
        // setLoaing(false);
        return;
      }
      const res = await loadSingeExportMessages(searchKey, offset);
      if (laetId === theLastId) {
        if (searchKey) {
          if (offset <= 0) {
            setMessageList(res);
            setTmpMessageList(res);
            dealFiterList(res);
          } else {
            const list = messageList.concat(res);
            setMessageList(list);
            setTmpMessageList(list);
            dealFiterList(res);
          }
        } else {
          setMessageList([]);
          setTmpMessageList([]);
        }
        setLoaing(false);
      }
    };
    // return async ()
    // loadSingeExportMessages(searchKey, offset)
    //     .then((res) => {
    //         if (laetId === theLastId) {
    //             if (searchKey) {
    //                 if (offset <= 0) {
    //                     setMessageList(res);
    //                     setTmpMessageList(res);
    //                 } else {
    //                     const list = messageList.concat(res);
    //                     setMessageList(list);
    //                     setTmpMessageList(list);
    //                 }
    //             }
    //         }
    //         // 控制加载更多
    //         // setLoadMore(res.length === limit ? true : false);
    //     })
    //     .finally(() => {
    //         setLoaing(false);
    //     });
  };

  const dealFilterItem = (list: any) => {
    const res: any[] = [];
    const noCardType = [ChatMessageType.TEXT, ChatMessageType.FILE, ChatMessageType.EGOV_FILE];
    list.map((item: any) => {
      if (sessionType === "single") {
        if (!item.isSingle) {
          return false;
        }
      }
      if (sessionType === "group") {
        if (item.isSingle) {
          return false;
        }
      }
      if (msgType === "file") {
        if (item.type !== ChatMessageType.FILE && item.type !== ChatMessageType.EGOV_FILE) {
          return false;
        }
      }
      if (msgType === "card") {
        if (noCardType.includes(item.type)) {
          return false;
        }
      }
      if (senderList?.length) {
        const includeSender = senderList.some(
          (sender: any) =>
          sender.app === item.sender.app &&
          sender.teamId === item.sender.teamId &&
          sender.pin === item.sender.pin
        );
        if (!includeSender) {
          return false;
        }
      };
      if (msgTime[1] && dayjs(item.timestamp).isAfter(msgTime[1], "day")) {
        return false;
      }
      if (msgTime[0] && dayjs(item.timestamp).isBefore(msgTime[0], "day")) {
        return false;
      }
      res.push(item);
    });
    return res;
  };
  const listFilter: any[] = [];
  const dealFiterList = (list: any[]) => {
    list.map((item: any) => {
      if (item.children.length) {
        const newChildren = dealFilterItem(item.children);
        if (newChildren) {
          if (newChildren.length === 1) {
            listFilter.push({...newChildren[0], isGroup: false});
          } else if(newChildren.length === 0) {
            return;
          } else {
            if (item?.timestamp !== newChildren[0]?.timestamp) {
              item.timestamp = newChildren[0]?.timestamp;
            }
            listFilter.push({...item, children: newChildren});
          }
        }
      } else {
        if (dealFilterItem([item]).length) {
          listFilter.push(item);
        }
      }
    });
    setFilterList(listFilter);
    setMessageList(listFilter);
  }

  useEffect(() => {
    dealFiterList(tmpmessageList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionType, msgType, senderList, msgTime]);

  useMemo(() => {
    init();
    if (activeKey !== SearchType.MessageHistory) {
      return;
    }
    getmessageList(keyWord)(laetId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyWord, activeKey]);
  // 加载更多数据
  const loadmoreFn = () => {
    // 加载
    if (!loadMore) {
      return;
    }
    const offset = (currPage.current += 1);
    // getmessageList(keyWord, offset);
  };
  const handleUrl = (item: any) => {
    const time = new Date();
    // const sMid = item.url.split('sMid=')[1].split('&')[0];
    // if (currentMid === sMid) {
    //     const index = item.url.indexOf('sText=');
    //     let url = item.url.substring(0, index - 1);
    //     history.push(`${url}`);
    // } else {
    //     history.push(item.url);
    // }
    // currentMid = sMid;
    history.push(item.url, time.toLocaleString());
    bus.emit("onHideGlobalSearch");
  };
  return (
    <SearchMessageHistoryListUI
      loading={loading}
      loadMore={loadMore}
      keyWord={keyWord}
      list={messageList}
      isShowBackBtn={isShowBackBtn}
      t={t}
      loadmoreFn={() => {
        loadmoreFn();
      }}
      onChangeDate={(list) => {
        analysisLog("xtbg_home_search_1641454991771", "33");
        setShowBackBtn(true);
        setSelectorSwitch && setSelectorSwitch(false);
        setLoadMore(false);
        // setTmpMessageList([...messageList]);
        setMessageList(list);
      }}
      backFn={() => {
        setShowBackBtn(false);
        setSelectorSwitch && setSelectorSwitch(true);
        setLoadMore(tmpmessageList.length === limit ? true : false);
        setMessageList(filterList);
        // setTmpMessageList([]);
      }}
      onOpenMessage={async (item) => {
        bus.emit("search:report-search-record", activeKey, item);
        bus.emit("search:save-history-keyword");
        updateMessages?.({ messages: [] });
        if (!(item as any).isSingle) {
          try {
            const res = await getGroupInfo({
              groupIds: [{ groupId: item.sessionId }]
            });
            if (res.groups[0].status === 0) {
              message.error("该群已解散！");
              return;
            } else {
              handleUrl(item);
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          try {
            const res = await imService.getEmployeeDetail({
              appId: (item as any).info.app,
              userId: (item as any).info.userId,
              teamId: (item as any).info.teamId
            });
            setTimeout(() => {
              handleUrl(item);
            });
          } catch (error) {
            message.error("该用户已被移除");
          }
        }
        analysisLog("xtbg_home_search_1641454991771", "33");
        // clearSessionMessage?.({ sessionId: item.sessionId });
      }}
    />
  );
};

function mapStateToProps({ chat }: any) { }

function mapDispatchToProps(dispatch: any) {
  return {
    async setHistoryMessage(data: { sessionId: string; historyMessage: ChatMessage }) {
      await dispatch({ type: "chat/setHistoryMessage", payload: data });
    },
    async clearSessionMessage(data: { sessionId: string }) {
      await dispatch({ type: "chat/clearSessionMessage", payload: data });
    },
    updateMessages(data: { messages: ChatMessage[] }) {
      dispatch({ type: "chat/updateMessages", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SeacrchMassageHistoryList);
